import * as React from 'react';
import styled from 'styled-components';
import { IPropertyResult } from './api';
import { currency } from './utils';

interface IPropertyImage {
  src: string;
}
interface IProperty {
  data: IPropertyResult;
}

export const Property = (props: IProperty) => {
  return (
    <PropertyWrapper
      target="_blank"
      rel="noopener noreferrer"
      href={`https://portal.eiendomsmeglerservice.no/eiendom/${props.data.external_reference}`}
    >
      <Image src={`${props.data.image}`}>
        {props?.data?.sold ? <div className='sold'>Solgt</div> : null}
      </Image>
      <div>
        <Adress>
          {props.data.street}, {props.data.place}
        </Adress>
        <Description></Description>
        <StrPrice>
          <Str>
            {props.data.prom && props.data.prom[0] ? props.data.prom[0] : ''}{' '}
            {props.data.prom && props.data.prom[1]
              ? `- ${props.data.prom[1]}`
              : ''}{' '}
            {props.data.prom && props.data.prom[0] && (
              <span dangerouslySetInnerHTML={{ __html: 'm&sup2' }} />
            )}
          </Str>
          <Price>
            {currency({ number: props.data.price[0], seperator: ' ' })}{' '}
            {props.data.price[1]
              ? `- ${currency({ number: props.data.price[1], seperator: ' ' })}`
              : ''}{' '}
            ,-
          </Price>
        </StrPrice>
        <SmallInfo>
          <Text>
            {props.data.ownership_type} *{' '}
            {props.data.estatetype && props.data.estatetype} *{' '}
            {props.data.rooms && `${props.data.rooms} soverom`}
          </Text>
        </SmallInfo>
      </div>
    </PropertyWrapper>
  );
};

const PropertyWrapper = styled.a`
  display: flex;
  color: #000;
  background-color: #fff;
  margin: 1em;
  border-bottom: 1px solid #ccc;
  padding: 0 0 1em 0;
  max-width: 800px;
  text-decoration: none;
`;

const Image = styled.div<IPropertyImage>`
  width: 300px;
  height: 200px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: none;
  margin: 0 1em 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .sold {
    background-color: white;
    padding: 20px;
    font-size: 40px;
    font-weight: 500;
    width: fit-content;
  }
`;

const Adress = styled.div`
  color: #474445;
  padding-top: 4px;
  font-size: 12px;
`;
const Description = styled.div`
  font-size: 16px;
  margin: 10px 0;
`;

const StrPrice = styled.div`
  display: flex;
  font-weight: 500;
`;

const Str = styled.div`
  margin-right: 1em;
`;
const Price = styled.div``;
const SmallInfo = styled.div`
  margin: 10px 0;
  font-size: 12px;
`;
const Text = styled.div`
  margin: 5px 0;
`;
